module.exports = __webpack_public_path__ + "static/media/phone.431dcbd4.webp";